import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAdsWithPromos = (ads) => ({
  type: actionTypes.SET_ADS_WITH_PROMOS,
  payload: ads
})
